import { render } from "./AccountingSync.vue?vue&type=template&id=120ba426&scoped=true"
import script from "./AccountingSync.vue?vue&type=script&lang=js"
export * from "./AccountingSync.vue?vue&type=script&lang=js"

import "./AccountingSync.vue?vue&type=style&index=0&id=120ba426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120ba426"]])

export default __exports__